import React, { useState } from "react";
import { useTheme } from "@material-ui/styles";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import {
  Dialog,
  DialogContent,
  CloseButton,
  ModeSelect,
  SelectButton
} from "./styles";
import { showGettingStartedDialog, showSupportDialog } from "../../../store/dialogs/dialogsActions";
import storageService from "../../../services/storage.service";
import config from "../../../config";

const GettingStartedDialog = (props) => {
  const theme = useTheme();
  const { showGettingStartedDialog, openGettingStartedDialog, showSupportDialog } = props;
  const [mode, setMode] = useState('zoom');

  const handleClose = () => {
    showGettingStartedDialog(false);
    storageService.setItem(config.IS_FIRST_VISIT, false);
  };

  const onClickSupportLink = () => {
    handleClose();
    showSupportDialog(true);
  };

  return (
    <Dialog
      open={openGettingStartedDialog}
      onClose={handleClose}
    >
      <DialogContent>
        <h4>Getting Started</h4>
        <ModeSelect>
          <SelectButton
            active={mode === 'zoom' ? 'true' : ''}
            onClick={() => setMode('zoom')}
          >
            Zoom
          </SelectButton>
          <SelectButton
            active={mode === 'phone' ? 'true' : ''}
            onClick={() => setMode('phone')}
          >
            Phone
          </SelectButton>
        </ModeSelect>
        {
          mode === 'phone' ?
            <div className="content">
              <div className="instruction">
                <h2>Step 1</h2>
                <div className="img-wrapper">
                  <img src={`/static/img/icon/${theme.name}/handset.png`} alt="handset"/>
                </div>
                <div className="text-wrapper">
                  <h6>Call the Alchemy Number</h6>
                  <ul>
                    <li>
                      Dial <Link to="#" className="support-link">01275 408 959</Link> from the device connected to your account & follow the audio instructions
                    </li>
                    <li>
                      Unregistered devices will result in unrecorded transcripts
                    </li>
                  </ul>
                </div>
              </div>
              <div className="arrow-next">
                <img src={`/static/img/icon/${theme.name}/arrow-next.png`} alt="handset"/>
              </div>
              <div className="instruction">
                <h2>Step 2</h2>
                <div className="img-wrapper">
                  <img src={`/static/img/icon/${theme.name}/dial.png`} alt="dial"/>
                </div>
                <div className="text-wrapper">
                  <h6>Choose One Option</h6>
                  <ul>
                    <li>
                      Option 1 lets you record calls between two people
                    </li>
                    <li>
                      Dial the number of the recipient and wait for the call to connect
                    </li>
                    <li>
                      Option 2 enables Self-Recording for digital dictations
                    </li>
                  </ul>
                </div>
              </div>
              <div className="arrow-next">
                <img src={`/static/img/icon/${theme.name}/arrow-next.png`} alt="handset"/>
              </div>
              <div className="instruction">
                <h2>Step 3</h2>
                <div className="img-wrapper">
                  <img src={`/static/img/icon/${theme.name}/zoom_step3.png`} alt="chatting"/>
                </div>
                <div className="text-wrapper">
                  <h6>Check Alchemy Machines</h6>
                  <ul>
                    <li>
                      Once you have completed your call or Self-Recording, simply hang up
                    </li>
                    <li>
                      Login to the <Link to="#">Alchemy Machines</Link> platform
                    </li>
                    <li>
                      The transcript should appear shortly
                    </li>
                    <li>
                      For a 10 minute meeting, it takes 1 minute to transcribe
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            :
            <div className="content">
              <div className="instruction">
                <h2>Step 1</h2>
                <div className="img-wrapper">
                  <img src={`/static/img/icon/${theme.name}/zoom_step1.png`} alt="handset"/>
                </div>
                <div className="text-wrapper">
                  <h6>Connect via Zoom Meeting</h6>
                  <ul>
                    <li>
                      Please ensure your Zoom account is connected to the <Link to="#">Alchemy Machines</Link> platform
                    </li>
                    <li>
                      Contact <Link to="#" className="support-link" onClick={() => onClickSupportLink()}>Support</Link> if you are unsure
                    </li>
                    <li>
                      Login to your Zoom account
                    </li>
                    <li>
                      Enter your online meeting as normal
                    </li>
                  </ul>
                </div>
              </div>
              <div className="arrow-next">
                <img src={`/static/img/icon/${theme.name}/arrow-next.png`} alt="handset"/>
              </div>
              <div className="instruction">
                <h2>Step 2</h2>
                <div className="img-wrapper">
                  <img src={`/static/img/icon/${theme.name}/zoom_step2.png`} alt="dial"/>
                </div>
                <div className="text-wrapper">
                  <h6>Press Record</h6>
                  <ul>
                    <li>
                      Once connected, notify the recipient that this meeting will be recorded
                    </li>
                    <li>
                      Press <Link to="#">Record</Link> on the bottom of your
                    </li>
                    <li>
                      Zoom navigation panel as highlighted above
                    </li>
                    <li>
                      For Self-Recordings, follow the same process
                    </li>
                  </ul>
                </div>
              </div>
              <div className="arrow-next">
                <img src={`/static/img/icon/${theme.name}/arrow-next.png`} alt="handset"/>
              </div>
              <div className="instruction">
                <h2>Step 3</h2>
                <div className="img-wrapper">
                  <img src={`/static/img/icon/${theme.name}/zoom_step3.png`} alt="chatting"/>
                </div>
                <div className="text-wrapper">
                  <h6>Check Alchemy Machines</h6>
                  <ul>
                    <li>
                      Once your meeting or Self-Recording is complete, simply end the call
                    </li>
                    <li>
                      Login to the <Link to="#">Alchemy Machines</Link> platform
                    </li>
                    <li>
                      The transcript should appear shortly
                    </li>
                    <li>
                      For a 10 minute meeting, it takes 1 minute to transcribe
                    </li>
                  </ul>
                </div>
              </div>
            </div>
        }
      </DialogContent>
      <CloseButton className="close-icon" onClick={handleClose}>
        X
      </CloseButton>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  openGettingStartedDialog: state.dialogsReducer.openGettingStartedDialog,
});

const mapDispatchToProps = {
  showGettingStartedDialog, showSupportDialog
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GettingStartedDialog));
